import styled from "styled-components/macro";

export const StyledContainer = styled.div`
  svg {
    path {
      fill: var(--grey-2);
    }
  }
`;

// Keep option styles on the option itself so they also apply when react-select
// portals the menu outside StyledContainer.
export const StyledOption = styled.div`
  text-align: left;
  padding: 10px;
  cursor: pointer;

  &.custom-option {
    display: flex;

    .icon-button-wrapper + span {
      margin-left: 0.5rem;
    }

    svg,
    path {
      fill: var(--primary-cta);
    }

    &.custom-option-selected svg,
    &.custom-option-selected:hover svg,
    &.custom-option-selected path,
    &.custom-option-selected:hover path {
      fill: #ffffff;
    }
  }

  &.custom-option::after {
    content: "...";
  }
`;
